import { render } from "./big-eye.vue?vue&type=template&id=72f6a168&scoped=true&ts=true"
import script from "./big-eye.vue?vue&type=script&lang=ts"
export * from "./big-eye.vue?vue&type=script&lang=ts"

import "./big-eye.vue?vue&type=style&index=0&id=72f6a168&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f6a168"]])

export default __exports__